import React, { Component } from 'react';
import { Input, Button, Form, Alert } from 'antd';
import { BarLoader } from 'react-spinners';
import firebase from 'firebase/app';
import 'firebase/auth';

const FormItem = Form.Item;

class ExternalLogin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            error: '',
            isLoading: false
        };
    }

    login(e) {

        e.preventDefault();
        this.setState({ isLoading: true });

        const { email, password } = this.state;

        externalLogin({ email, password }, (uid, error) => {

            this.setState({ isLoading: false, email: '', password: '', error: error });

            if (uid && window.xchild) {

                const { onLogin } = this.props;
                if (onLogin) {
                    onLogin(email, uid);
                }

                // close when valid uid is received
                window.xchild.close();
            }
        });
    }

    onAlertClose() {
        setTimeout(() => {
            this.setState({ error: '' });
        }, 1000);
    }

    renderLoading() {
        return (
            <div style={{ width: '100%', marginTop: 24, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <BarLoader color={'#455963'} loading width={380} />
            </div>
        );
    }

    render() {
        const { error, isLoading, email, password } = this.state;
        // const { originApp } = this.props;

        return (
            <form onSubmit={this.login.bind(this)}>
                <div className="loginStyle">
                    <div className="loginContent">
                        <img className="logo" src="/resources/images/iphone-logo128.png" alt="" />
                        {/* {originApp ? <Alert message={originApp} type="info" showIcon closable /> : null} */}
                        {(error) ? <Alert message={error} type="error" showIcon closable onClose={this.onAlertClose.bind(this)} style={{ paddingRight: 30, marginBottom: 14 }} /> : null}
                        <FormItem
                            label="Email"
                            colon
                            className="form-name"
                            hasFeedback
                        >
                            <Input
                                className="input"
                                placeholder="Email"
                                size="large"
                                disabled={isLoading}
                                prefix={<img src="/resources/images/ic-username.svg" alt="" />}
                                type="text"
                                value={email}
                                onChange={event =>
                                    this.setState({ email: event.target.value })
                                }
                            />
                        </FormItem>
                        <FormItem
                            label="Password"
                            colon
                            className="form-name"
                            hasFeedback
                        >
                            <Input
                                className="input"
                                placeholder="Password"
                                size="large"
                                disabled={isLoading}
                                prefix={<img src="/resources/images/ic-password.svg" alt="" />}
                                type="password"
                                value={password}
                                onChange={event =>
                                    this.setState({ password: event.target.value })
                                }
                            />
                        </FormItem>
                        {isLoading ? this.renderLoading() : <Button className="btnLogin" htmlType="submit" size="large" >Login</Button>}
                    </div>
                </div>
            </form>
        );
    }
}

function externalLogin({ email, password }, callback) {

    firebase.auth().signInWithEmailAndPassword(email, password)
        .then((credential) => {
            if (callback) {
                callback(credential.user.uid, null);
            }
        })
        .catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            if (callback) {
                callback(null, errorMessage);
            }
        });
}

export default ExternalLogin;



// WEBPACK FOOTER //
// ./src/views/external-login/index.jsx